module.exports = __webpack_public_path__ + "img/logo-sbt.0a0c50d9.png";